import { PartnershipTierLevel } from '@urbanx/agx.agencies.client';

export const tierOrder: Record<PartnershipTierLevel, number> = {
  [PartnershipTierLevel.Bronze]: 1,
  [PartnershipTierLevel.Silver]: 2,
  [PartnershipTierLevel.Gold]: 3,
  [PartnershipTierLevel.Platinum]: 4,
  [PartnershipTierLevel.XPartner]: 5,
};
